import _ from 'lodash';

import { DownloadStatePart } from '../../setup/types';

export const isDownloading = (state: DownloadStatePart, key: string) =>
    _.get(state, `download.pendingDownloads.${key}`, false);
